import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Link as RouterLink } from "react-router-dom";
import getListaLight from "../assets/images/getlistaLight.svg"; // Make sure this path and file exist

const HeaderPublic = () => {
  return (
    <AppBar position="static" elevation={0} sx={{ background: "#000", color: "#fff", px: 1 }} >
      <Container maxWidth="100vh">
        <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
          {/* Logo */}
          <Box display="flex" alignItems="center" component={RouterLink} to="/">
            <img src={getListaLight} alt="Logo" />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default HeaderPublic;